/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import axios from 'axios'
import * as Yup from 'yup'
import GenerateField from 'lib/GenerateField'
import { usePartnerData } from 'hooks/usePartnerData'
import { useGlobalStateContext } from '../../store'

const apiURL = process.env.GATSBY_ACS_API_URL

const AcquiaFormHandle = ({ redirectTo, id, resetForm, modalSubmit }) => {
  // keep track of whether the form has been submitted
  const [isSent, setIsSent] = useState(false)
  const [acsForm, setAcsForm] = useState(null)
  const [error, setError] = useState(null)
  const context = useGlobalStateContext()
  const { slug, programDetailUrl, degreeLevel } = context

  useEffect(() => {
    let url = `/api/acs/forms`
    if (id) {
      url = `/api/acs/forms/${id}`
    }

    axios
      .get(url)
      .then((response) => {
        if (!response.status === 200) {
          throw new Error(`HTTP error: ${response.status}`)
        }
        return response.data
      })
      .then((data) => {
        setAcsForm(data)
      })
      .catch((error) => {
        setError(`Request failed: ${error.message}`)
      })
  }, [id])

  const [formValues, setFormValues] = useState({})

  const [theForm, setTheForm] = useState(null)
  const [theFields, setTheFields] = useState([])

  const modifyFields = (fields) =>
    fields.map(
      (field) =>
        // if (
        //     field.conditions &&
        //     field.conditions.values &&
        //     field.conditions.values.length > 0
        // ) {
        //     return {
        //         ...field,
        //         initialHide: true,
        //     };
        // }
        field
    )

  useEffect(() => {
    if (acsForm) {
      const { fields, ...otherFormProps } = acsForm.form
      const modifiedFields = modifyFields(fields)
      setTheFields(modifiedFields)
      setTheForm(otherFormProps)
    }
  }, [acsForm])

  const onSubmit = async (values, { setSubmitting, setFieldValue }) => {
    try {
      const theFormData = {
        ...values,
        formId: theForm.id,
        formName: theForm.name,
        messenger: 1,
        c_intended_program: slug,
      }

      await axios
        .post(
          `${apiURL}/form/submit?formId=${theForm.id}`,
          {
            mauticform: theFormData,
          },
          {
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
        )
        .then((res) => {
          setIsSent(true)
        })
        .catch((err) => {})

      setSubmitting(false)
    } catch (error) {
      setSubmitting(false)
    }
  }

  const initialValues = {}

  const [fieldsProcessed, setFieldsProcessed] = useState(false)

  useEffect(() => {
    // console.log('theFields', theFields);
    if (theFields.length > 0 && !fieldsProcessed) {
      // console.log('🚨 the fields', theFields);
      const newFormValues = {}
      theFields.forEach((field) => {})
      setFormValues((prev) => ({
        ...prev,
        ...newFormValues,
      }))

      setFieldsProcessed(true)
    }
  }, [theFields, fieldsProcessed])

  if (error) return <p>Error loading form. Error: {error}</p>
  if (!acsForm) return <p className="loading">Loading...</p>

  // Assume `fields` is the array of form fields received from the API
  const validationSchema = Yup.object().shape(
    theFields.reduce((schema, field) => {
      // For each field, create a Yup validation object based on its validation rules
      let fieldValidation = ''

      if (field.type === 'text' || field.type === 'email') {
        fieldValidation = Yup.string()
      } else if (field.type === 'number') {
        fieldValidation = Yup.number()
      } else {
        fieldValidation = Yup.mixed() // Initialize with a generic Yup type
      }

      if (field.isRequired) {
        fieldValidation = fieldValidation.required(field.validationMessage || `${field.label} is required`)
      }

      if (field.type === 'email') {
        fieldValidation = fieldValidation.email('Invalid email')
      }

      // if field is a number, and field alias is zip_code, add min and max length
      if (field.alias === 'zip_code') {
        fieldValidation = fieldValidation.test(
          'len',
          'Zip Code needs to be excatly 5 digits',
          (val) => !val || val.toString().length === 5
        )
      }

      // Add more validation rules here as needed

      // Add the validation object to the schema object using the field's alias as the key
      // schema[field.alias] = fieldValidation;
      return { ...schema, [field.alias]: fieldValidation }
      // return schema;
    }, {})
  )

  return (
    <Formik
      enableReinitialize
      initialValues={formValues || initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ errors, isSubmitting, isValid, dirty }) =>
        !isSent ? (
          <Form>
            {theFields.map((field) => (
              <GenerateField field={field} error={errors[field.alias]} formData={theFields} key={field.id} />
            ))}
          </Form>
        ) : (
          <ThanksMessage sendTo={programDetailUrl} resetForm={resetForm} />
        )
      }
    </Formik>
  )
}

const ThanksMessage = ({ sendTo, resetForm }) => {
  const { shortName } = usePartnerData()

  return (
    <div className="thanks-message">
      <h2>Thank You, We'll Be in Touch</h2>
      <p className="featured">Explore Next Steps at {shortName}</p>
      <p>
        We can't wait to tell you more about your program of interest. You should expect to hear from us soon. Until
        then, you can explore our website for information regarding admission requirements, courses, faculty, and more.
        Take the next step in your journey with us.
      </p>
      <a href={sendTo || 'https://www.morgan.edu'} className="button">
        {sendTo ? 'See Program Details' : 'Explore Morgan'}
      </a>
      {process.env.NODE_ENV === 'development' && (
        <button type="button" onClick={() => resetForm(false)}>
          Reset
        </button>
      )}
    </div>
  )
}

export default AcquiaFormHandle
